import axios from "axios";
import { AUTH_TOKEN } from "../constants";
export const API_V1 = "/api/v1";

export const accessToken = "token from local storage";

export const headers = {
  Authorization: `Bearer ${accessToken}`,
};

// export const baseUrl = "http://167.71.76.48:7250";
// export const baseUrl = "http://192.168.1.99:7250";
// export const baseUrl = "http://192.168.1.211:7250";
// export const baseUrl = "http://192.168.1.211:7250";
// export const baseUrl = "http://192.168.1.203:7250";
// export const baseUrl = "http://192.168.1.99:7250";
export const baseUrl = "https://apis.tutify.online";
export const baseUrl2 = "https://apis.tutify.online";

const api = axios.create({
  baseURL: baseUrl,
  validateStatus: () => true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(AUTH_TOKEN);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;

// export const API = `${baseUrl}${API_V1}`;

export const ADMIN_API = `${baseUrl}/admin/counts`;
export const TEACHER_API = `${baseUrl}/teachers`;
export const UPLOAD = `${baseUrl}/upload`;
export const STUDENT_API = `${baseUrl}/students`;
